import script from "./TabItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabItem.vue?vue&type=script&lang=ts&setup=true"

import "./TabItem.vue?vue&type=style&index=0&id=19a1987c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a1987c"]])

export default __exports__